import { t } from 'i18next'
import i18n from 'lib/i18'
import { contentLanguages } from 'lib/languages'
import { CategorisationInfo, CategoryField } from 'types/model/common'

export const getCategoryFormat = (
  categorisationInfo: CategorisationInfo[],
  categories: CategoryField[]
) => {
  categories.map((category) => {
    const temp = category
    const tree = categorisationInfo.find(
      (categorisation) => categorisation.tree === category.tree
    )
    if (!tree || !tree.categories || !temp.category) return null
    const categoryInfoWithName =
      tree.categories?.find(
        (category) => category.extId === temp.category.extId
      ) || null
    if (!categoryInfoWithName || !categoryInfoWithName.name) return null

    // find name with UI language if possible, then with first content language
    const categoryName =
      categoryInfoWithName.name.find(
        (type) => type['@languageCode'] === i18n.language
      ) ||
      categoryInfoWithName.name.find(
        (type) => type['@languageCode'] === contentLanguages[0]
      )
    temp.category.name = categoryName?.$ || ''
    return temp
  })
  return categories
}

export const formatLangContentField = (options: { [lang: string]: string }) => {
  const formattedOptions = Object.keys(options).reduce((acc, key) => {
    if (options[key].length > 0) {
      const formattedLang = {
        $: options[key] || '',
        '@languageCode': key,
      }
      acc.push(formattedLang)
    }
    return acc
  }, [] as { $: string; '@languageCode': string }[])
  return formattedOptions
}

export const formatLangContentListField = (options: {
  [lang: string]: string
}) => {
  const formattedOptions = Object.keys(options).reduce((acc, key) => {
    if (options[key].length > 0) {
      const array = options[key].split(',')
      array.forEach((item) => {
        const formattedLang = {
          $: item.trim() || '',
          '@languageCode': key,
        }
        acc.push(formattedLang)
      })
    }
    return acc
  }, [] as { $: string; '@languageCode': string }[])
  return formattedOptions
}

export const convertBooleanToString = (value: boolean | undefined) => {
  if (value === undefined || value === null) return null
  return value ? t('true') : t('false')
}
